class LeadImageModalCtrl {
  close() {
    this.modalInstance.dismiss();
  }
}

export default LeadImageModalCtrl;
